export default "__VITE_ASSET__7b67ebf2__"